/**
 * Mobile sticky Place order bar when the sidebar scrolls away.
 */

function getConfig() {
	return window.doneCommerce || {};
}

function readTotal() {
	const total =
		document.querySelector('.dc-checkout__sidebar .order-total .amount') ||
		document.querySelector('#order_review .order-total .amount') ||
		document.querySelector('.order-total .woocommerce-Price-amount');
	return total?.textContent?.trim() || '';
}

function isDrawerOpen() {
	const drawer = document.getElementById('dc-cart-drawer');
	return Boolean(drawer && !drawer.hidden && drawer.classList.contains('is-open'));
}

export function initStickyCheckout() {
	if (!document.body.classList.contains('woocommerce-checkout')) {
		return;
	}

	const sidebar = document.querySelector('[data-checkout-sidebar], .dc-checkout__sidebar');
	const placeOrder = document.querySelector('#place_order');
	if (!sidebar || !placeOrder) {
		return;
	}

	const bar = document.createElement('div');
	bar.className = 'dc-sticky-checkout';
	bar.hidden = true;
	bar.setAttribute('data-sticky-checkout', '');

	const total = document.createElement('span');
	total.className = 'dc-sticky-checkout__total';
	total.setAttribute('data-sticky-checkout-total', '');

	const button = document.createElement('button');
	button.type = 'button';
	button.className = 'dc-sticky-checkout__button';
	button.textContent = placeOrder.value || getConfig().i18n?.placeOrder || 'Place order';

	button.addEventListener('click', () => {
		if (placeOrder.disabled) {
			return;
		}
		placeOrder.click();
	});

	bar.append(total, button);
	document.body.appendChild(bar);

	const mq = window.matchMedia('(max-width: 767px)');

	const sync = () => {
		total.textContent = readTotal();
		button.disabled = Boolean(placeOrder.disabled);
		button.textContent = placeOrder.value || button.textContent;
	};

	const updateVisibility = (inView) => {
		const show = mq.matches && !inView && !isDrawerOpen();
		bar.hidden = !show;
		document.body.classList.toggle('dc-sticky-checkout-visible', show);
	};

	let inView = true;
	const observer = new IntersectionObserver(
		(entries) => {
			inView = Boolean(entries[0]?.isIntersecting);
			updateVisibility(inView);
		},
		{ root: null, threshold: 0, rootMargin: '0px' }
	);
	observer.observe(sidebar);

	mq.addEventListener('change', () => updateVisibility(inView));
	document.body.addEventListener('updated_checkout', () => {
		sync();
		window.setTimeout(() => updateVisibility(inView), 0);
	});

	const drawer = document.getElementById('dc-cart-drawer');
	if (drawer) {
		const drawerObserver = new MutationObserver(() => updateVisibility(inView));
		drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['hidden', 'class'] });
	}

	sync();
}
